import { useEffect, useState } from 'react';

import defu from 'defu';
import _ from 'lodash';

import apiFetch from '@wordpress/api-fetch';

import type { FormType, WrapperTypeEnums } from '@/src/Types/Blocks/Form';
import type { GForm } from '@/src/Types/GF/form';
import type { ContainerTypeEnums, PositionsAlignement } from '@/src/Types/Shared/Common';
import type { Options } from '@/src/Types/Shared/Options';
import { FormStyle, getBtnStyle, getSingleBtnStyle } from '@Views/Shared/GlobalStyles/GlobalStyles';

import Form from './Block';

type FormRegister = {
	block: FormType;
	containerType: ContainerTypeEnums;
	wrapperType: WrapperTypeEnums;
	headingAlign: PositionsAlignement;
	options: Options;
};

export default function Register(props: FormRegister) {
	const {
		block,
		containerType = 'wide',
		wrapperType = 'center',
		headingAlign = 'center',
		options,
	} = props;

	const { id, title, titleFormat, description, forms: form_id, composition, style = {} } = block;

	const [form, setForm] = useState<GForm>();

	useEffect(() => {
		const _posts: Promise<string> = apiFetch({
			path: '/minos/v1/getform/',
			method: 'POST',
			data: { form: form_id },
		});
		_posts.then((json: string) => {
			const formObj = JSON.parse(json);
			setForm(formObj);
		});
	}, [form_id]);

	let propsForm: FormType = {
		id: id,
		style: style,
		containerType: containerType,
		wrapperType: wrapperType,
		headingAlign: headingAlign,
		title: title,
		titleFormat: titleFormat,
		description: description,
		form: form,
		form_id: form_id,
		ctasStyle: getBtnStyle(options, options.blocks.form.default.ctasStyle),
		btnSubmitStyle: getSingleBtnStyle(options, options.blocks.form.default.btnSubmitStyle),
		placement: block.placement,
		sectionDecoration: options.layout.sectionDecoration,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(options.blocks.form.compositions, { id: composition });
		if (compoOptions) {
			propsForm = defu(compoOptions as FormType, propsForm);
			propsForm.ctasStyle = getBtnStyle(options, compoOptions.ctasStyle);
			propsForm.style = FormStyle(options, compoOptions);
			propsForm.btnSubmitStyle = getSingleBtnStyle(options, compoOptions.btnSubmitStyle);
		}
	}

	return <Form {...propsForm} />;
}
